<template>
  <v-container>
    <v-layout align-center justify-center column>
      <img src="/img/hg-logo.png" alt="HomeGauge logo"/>
      <h1><strong>{{message}}</strong></h1>
      <span>{{description}}</span>
      <span>If you are not redirected, click <a :href="createdRedirectUrl">Here</a></span>
    </v-layout>
  </v-container>
</template>

<script>
const dataLayer = window.dataLayer || [];
export default {
  props: {
    redirectUrl: {
      type: String,
      default: '',
    },
    hostedPageId: {
      type: String,
      default: '',
    },
    status: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      message: 'Loading your purchase information...',
      description: 'Wait a moment while we redirect you to your account',
      loading: true,
      loggedInPerson: undefined,
    };
  },
  computed: {
    createdRedirectUrl() {
      return new URL(this.redirectUrl || `${process.env.VUE_APP_IDB_URL}?id=${this.hostedPageId}&state=${this.status}`);
    },
  },
  mounted() {
    this.$store.dispatch('Person/getLoggedInPerson')
      .then(this.setLoggedInPerson)
      .then(() => this.$store.dispatch('Subscription/acknowledge', this.hostedPageId))
      .then(this.setMessage)
      .then(this.sendToGtm)
      .then(this.redirectToUrl)
      .catch(this.setErrorMessage);
  },
  methods: {
    setLoggedInPerson(loggedInPersonResponse) {
      this.loggedInPerson = loggedInPersonResponse;
      return loggedInPersonResponse;
    },
    setThankYouMessage() {
      this.message = 'Thank you, we have processed your request.';
      this.description = 'You will be redirected to your account shortly';
    },
    setMessage(acknowledgeResponse) {
      this.setThankYouMessage();
      return acknowledgeResponse;
    },
    setErrorMessage(errorResponse) {
      const conflictHttpResponse = 409;

      if (errorResponse.status === conflictHttpResponse && ['acknowledged', 'succeeded'].includes(this.status)) {
        this.setThankYouMessage();
        this.redirectToUrl();
      } else {
        this.message = errorResponse.data?.body?.message ?? 'An error occurred while retrieving your purchase information';
        this.description = 'Please contact HomeGauge support';
        this.loading = false;

        throw new Error(this.message);
      }
    },
    sendToGtm(acknowledgeResponse) {
      acknowledgeResponse.body.items.forEach(item => {
        const itemToPush = {
          event: 'chargebee_purchase',
          sku: item.entityId,
          product_name: item.description,
          value: (item.amount - item.discountAmount) / 100,
          person_id: this.loggedInPerson.personId,
        };

        // eslint-disable-next-line no-undef
        dataLayer.push(itemToPush);
      });

      return acknowledgeResponse;
    },
    redirectToUrl() {
      const url = this.createdRedirectUrl;
      // eslint-disable-next-line no-undef
      dataLayer.push({ redirectUrl: url });
      const timeOut = 5000;
      setTimeout(() => {
        this.loading = false;
        window.location = url;
      }, timeOut);
    },
  },
};
</script>
<style lang="scss" scoped>
.layout {
  text-align: center;
}
</style>
